import { render, staticRenderFns } from "./SitewidePreviewBanner.vue?vue&type=template&id=32f6b08d&scoped=true"
import script from "./SitewidePreviewBanner.vue?vue&type=script&lang=js"
export * from "./SitewidePreviewBanner.vue?vue&type=script&lang=js"
import style0 from "./SitewidePreviewBanner.vue?vue&type=style&index=0&id=32f6b08d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f6b08d",
  null
  
)

export default component.exports